import React from 'react';
import useSocialShareConnectedModal from '../useSocialShareConnectedModal';
import { BlueskySocialShareProvider } from './BlueskySocialShare';
import { FacebookSocialShareProvider } from './FacebookSocialShare';
import { InstagramSocialShareProvider } from './InstagramSocialShare';
import { LinkedInSocialShareProvider } from './LinkedInSocialShare';
import { ThreadsSocialShareProvider } from './ThreadsSocialShare';
import { TikTokSocialShareProvider } from './TikTokSocialShare';
import { TwitterSocialShareProvider } from './TwitterSocialShare';
import { YouTubeSocialShareProvider } from './YouTubeSocialShare';

export type SocialSharePlatformsProps = {
  children: React.ReactNode;
};

/**
 * Wraps the active platform's provider around children. Only one platform
 * mounts at a time. Must be used inside SocialShareProvider.
 */
const SocialSharePlatforms: React.FC<SocialSharePlatformsProps> = ({
  children,
}) => {
  const { params } = useSocialShareConnectedModal();

  const platform = params?.platform;

  if (!platform) {
    return null;
  }

  let PlatformProvider: React.FC | null = null;

  switch (platform) {
    case 'bluesky':
      PlatformProvider = BlueskySocialShareProvider;
      break;

    case 'facebook':
      PlatformProvider = FacebookSocialShareProvider;
      break;

    case 'instagram':
      PlatformProvider = InstagramSocialShareProvider;
      break;

    case 'linkedin':
      PlatformProvider = LinkedInSocialShareProvider;
      break;

    case 'threads':
      PlatformProvider = ThreadsSocialShareProvider;
      break;

    case 'tiktok':
      PlatformProvider = TikTokSocialShareProvider;
      break;

    case 'twitter':
      PlatformProvider = TwitterSocialShareProvider;
      break;

    case 'youtube':
      PlatformProvider = YouTubeSocialShareProvider;
      break;

    default:
      PlatformProvider = null;
      break;
  }

  return <PlatformProvider>{children}</PlatformProvider>;
};

export default SocialSharePlatforms;
